/*eslint-disable*/
import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Label,
  FormGroup,
  Row,
  Input,
  Container,
  CardHeader,
  CardFooter,
  Button,
  Form, FormFeedback
} from "reactstrap";
import { Link, useHistory } from "react-router-dom";
import axios from 'axios';
import SimpleHeader from "components/Headers/SimpleHeader.js";

export default function EditCategory(props) {
  const token = localStorage.getItem("token");
  const [category, setCategory] = useState("");
  const [categoryError, setCategoryError] = useState(null);
  let history = useHistory();
  const [isLoading, setLoading] = useState(false);

  const validateForm = () => {
    let error = false;
    if (category === "") {
      setCategoryError("invalid");
      error = true;
    }
    return error;
  };

  useEffect(() => {
    getAllCategoryById();
  }, []);

  const getAllCategoryById = () => {
    fetch(`${process.env.REACT_APP_API_BASE_URL}/merchantCategories/${props.match.params.id}`, {
      method: 'GET', // or 'PUT'
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(),
    })
      .then(response => response.json())
      .then(data => {
        const responseData = data.response_data;
        setCategory(responseData.merchant_category_name)
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  function UpdateData() {
    setLoading(true);
    let data = {
      merchantCategoryName: category
    }
    axios.post(`${process.env.REACT_APP_API_BASE_URL}/merchantCategories/update/${props.match.params.id}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    })
      .then(function (response) {
        history.push("/admin/category");
      })
      .then(json => {
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error)
      })
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) {
      UpdateData();
    }
  }
  return (
    <>
      <SimpleHeader name="Edit Kategori" parentName="Admin" />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <Card>
              <CardBody>
                <Form onSubmit={handleSubmit} >
                  <CardHeader>
                    <h3>Edit Kategori</h3>
                  </CardHeader>
                  <CardBody>
                    <FormGroup>
                      <Label
                        className="form-control-label"
                        htmlFor="serial_number"
                      >
                        Nama Kategori
                                            </Label>
                      <Input
                        type="text"
                        name="kategori_name"
                        placeholder="Masukan Nama Kategori"
                        value={category}
                        invalid={categoryError === "invalid"}
                        onChange={(e) => {
                          setCategory(e.target.value);
                          if (e.target.value !== "") {
                            setCategoryError("");
                          }
                        }}
                      />
                      <FormFeedback>Nama Kategori tidak boleh kosong</FormFeedback>
                    </FormGroup>
                  </CardBody>
                  <CardFooter>
                    {!isLoading && (<Button color="primary" type="submit">
                      Simpan
                    </Button>)}
                    {isLoading && (<Button color="primary" disabled>
                      <i className="fas fa-spinner fa-spin"></i>{""}
                      loading...
                    </Button>)}
                    <Link class="btn btn-info" to="/admin/category">
                      Cancel
                    </Link>
                  </CardFooter>
                </Form>
              </CardBody>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
}
